import { useState, useEffect, useRef } from 'react';

const useViewport = () => {
  const isClient = typeof window !== 'undefined';

  const getSize = () => ({
    width: isClient ? window.innerWidth : undefined,
    height: isClient ? window.innerHeight : undefined,
  });

  const [windowSize, setWindowSize] = useState(getSize());

  const latestWindowSize = useRef(windowSize);
  useEffect(() => {
    const handleResize = () => {
      const newSize = getSize();
      // update state only if width is changed
      if (newSize.width !== latestWindowSize.current.width) {
        setWindowSize(newSize);
        latestWindowSize.current = newSize;
      }
    };

    window.addEventListener('resize', handleResize);

    // eslint-disable-next-line consistent-return
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
};

export default useViewport;
